<template>
  <InvoiceModifier></InvoiceModifier>
</template>

  <script>
  import InvoiceModifier from '@/components/InvoiceModifier.vue'

  export default {
    components: {InvoiceModifier},
   
  }
  </script>
